"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKeyMaps = createKeyMaps;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const errors_1 = require("../errors");
function createKeyMaps(model, formMetaState, initialValues) {
    const keyToNode = {};
    const nodeToKey = {
        terms: {},
        iterables: {},
    };
    const keyConflicts = [];
    for (const term of Object.values(model.terms)) {
        let keyFn = null;
        if (term.key?.type === "syntax-tree") {
            keyFn = term.key.tree;
        }
        else if (model.key?.type === "syntax-tree") {
            keyFn = model.key.tree;
        }
        const key = keyFn
            ? String(tryExecSyntax(keyFn, 
            // key-fn should not include key, env, or anything else not available at compile time
            (0, pi_syntax_tools_1.getContext)({
                ...formMetaState,
                this: {
                    values: initialValues,
                    term: formMetaState.terms[term.name],
                },
            }), term.key?.type === "syntax-tree" ? term.name : undefined))
            : term.name;
        if (keyToNode[key]) {
            keyConflicts.push({
                node: {
                    type: "term",
                    termName: term.name,
                },
                keys: [key],
            });
        }
        keyToNode[key] = {
            type: "term",
            termName: term.name,
        };
        nodeToKey.terms[term.name] = key;
    }
    for (const iterable of Object.values(model.iterables)) {
        let max = Number(iterable.max);
        if (isNaN(max) || max < 1) {
            max = 1;
        }
        if (!nodeToKey.iterables[iterable.name]) {
            nodeToKey.iterables[iterable.name] = [];
        }
        const conflicts = {};
        for (let index = 0; index < max; index += 1) {
            const instance = {};
            for (const iterableTerm of Object.values(iterable.terms)) {
                // key-fn should not include key, env, or anything else not available at compile time
                const iterableContext = (0, pi_syntax_tools_1.getContext)({
                    ...formMetaState,
                    this: {
                        values: initialValues,
                        index,
                        position: index + 1,
                        iterable: formMetaState.iterables[iterable.name],
                        term: formMetaState.iterables[iterable.name].terms[iterableTerm.name],
                    },
                });
                let keyFn = null;
                if (iterableTerm.key?.type === "syntax-tree") {
                    keyFn = iterableTerm.key.tree;
                }
                else if (iterable.key?.type === "syntax-tree") {
                    keyFn = iterable.key.tree;
                }
                const key = keyFn
                    ? String(tryExecSyntax(keyFn, iterableContext, iterableTerm.key?.type === "syntax-tree"
                        ? iterableTerm.name
                        : undefined, iterable.name))
                    : iterableTerm.name + (index + 1);
                if (keyToNode[key]) {
                    if (conflicts[iterableTerm.name]) {
                        conflicts[iterableTerm.name].push(key);
                    }
                    else {
                        conflicts[iterableTerm.name] = [key];
                    }
                }
                keyToNode[key] = {
                    type: "iterable-term",
                    iterableName: iterable.name,
                    termName: iterableTerm.name,
                    iterableIndex: index,
                };
                instance[iterableTerm.name] = key;
            }
            nodeToKey.iterables[iterable.name].push(instance);
        }
        for (const [termName, keys] of Object.entries(conflicts)) {
            keyConflicts.push({
                node: {
                    type: "iterable-term",
                    iterableName: iterable.name,
                    termName,
                },
                keys,
            });
        }
    }
    return { keyToNode, nodeToKey, keyConflicts };
}
function tryExecSyntax(syntax, context, termName, iterableName) {
    try {
        return String((0, pi_syntax_tools_1.execSyntax)(syntax, context));
    }
    catch (ex) {
        if (ex instanceof Error) {
            throw new errors_1.KeyExecutionError(ex.message, syntax, termName, iterableName);
        }
        throw ex;
    }
}
//# sourceMappingURL=map-keys.js.map